import React from 'react';
import useAuthStore from '../stores/useAuthStore';

const GlobalLoader = () => {
  const { isGlobalLoading } = useAuthStore();

  if (!isGlobalLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="w-14 h-14 border-4 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default GlobalLoader;
